import { render, staticRenderFns } from "./posted.vue?vue&type=template&id=7bb1b666&scoped=true"
import script from "./posted.vue?vue&type=script&lang=js"
export * from "./posted.vue?vue&type=script&lang=js"
import style0 from "./posted.vue?vue&type=style&index=0&id=7bb1b666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb1b666",
  null
  
)

export default component.exports